export default __webpack_public_path__ + "static/media/trash.6242e09f.svg";